import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import theme from '../../theme';

const { pageHeaderHeight, adminContentPadding } = theme.constants;

export const productsPageClass = css`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${pageHeaderHeight} - ${adminContentPadding} - ${adminContentPadding});
  overflow: hidden;
  background-color: #f8f9fa;

  @media (max-width: 768px) {
    height: calc(100vh - ${pageHeaderHeight});
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.75rem;
  }
`;

export const TabBar = styled.div`
    display: flex;
    gap: 0;
    border-bottom: 2px solid #dee2e6;
    margin-bottom: 0;
`;

export const Tab = styled.button<{ $active: boolean }>`
    padding: 10px 24px;
    font-size: 0.9rem;
    font-weight: ${(props) => (props.$active ? '600' : '400')};
    color: ${(props) => (props.$active ? '#0066cc' : '#6c757d')};
    background: none;
    border: none;
    border-bottom: 2px solid ${(props) => (props.$active ? '#0066cc' : 'transparent')};
    margin-bottom: -2px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        color: #0066cc;
    }
`;

export const SplitLayout = styled.div`
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 1.5rem;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const SplitPanel = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
`;

export const SplitPanelTitle = styled.div`
    font-weight: 700;
    font-size: 0.85rem;
    color: #2c3e50;
    padding: 0.5rem 0.75rem;
    border-bottom: 2px solid #dee2e6;
    background: #f8f9fa;
    border-radius: 4px 4px 0 0;
    flex-shrink: 0;
`;

export const WideOnly = styled.div`
    display: none;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    @media (min-width: 1441px) {
        display: flex;
        flex-direction: column;
    }
`;

export const NarrowOnly = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 768px) {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    @media (min-width: 1441px) {
        display: none;
    }
`;